(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
	typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
	(factory((global.reactAccessibleTooltip = {}),global.React));
}(this, (function (exports,React) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var counter = 0;

var Tooltip = function (_Component) {
    _inherits(Tooltip, _Component);

    function Tooltip(props) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.state = {
            isFocused: false,
            isHovered: false
        };

        _this.onFocus = function () {
            _this.setState({ isFocused: true });
        };

        _this.onBlur = function (_ref) {
            var relatedTarget = _ref.relatedTarget,
                currentTarget = _ref.currentTarget;

            // relatedTarget is better for React testability etc, but activeElement works as an IE11 fallback:
            var newTarget = relatedTarget || document.activeElement;

            // The idea of this logic is that we should only close the tooltip if focus has shifted from the tooltip AND all of its descendents.
            if (!(newTarget && newTarget instanceof HTMLElement)) {
                _this.setState({ isFocused: false });
            } else if (!currentTarget.contains(newTarget)) {
                _this.setState({ isFocused: false });
            }
        };

        _this.onMouseEnter = function () {
            _this.setState({ isHovered: true });
        };

        _this.onMouseLeave = function () {
            _this.setState({ isHovered: false });
        };

        _this.handleTouch = function (_ref2) {
            var target = _ref2.target;
            var _document = document,
                activeElement = _document.activeElement;


            if (activeElement instanceof Element && target instanceof Element && _this.container instanceof Element && !_this.container.contains(target) && // touch target not a tooltip descendent
            _this.state.isFocused // prevent redundant state change
            ) {
                    _this.setState({ isFocused: false });
                    activeElement.blur();
                } else if (activeElement instanceof Element && target instanceof Element && _this.container instanceof Element && _this.container.contains(target) && // touch target is on tooltip descendant
            !_this.state.isFocused // prevent redundant state change
            ) {
                    _this.setState({ isFocused: true });
                }
        };

        _this.handleKeyDown = function (_ref3) {
            var key = _ref3.key,
                keyCode = _ref3.keyCode,
                which = _ref3.which;

            if (key === 'Escape' || keyCode === 27 || which === 27) {
                _this.setState({ isFocused: false });
            }
        };

        _this.identifier = 'react-accessible-tooltip-' + counter;
        counter += 1;
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.handleKeyDown);
            document.addEventListener('touchstart', this.handleTouch);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.handleKeyDown);
            document.removeEventListener('touchstart', this.handleTouch);
        }

        // This handles the support for touch devices that do not trigger blur on 'touch-away'.

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                Label = _props.label,
                Overlay = _props.overlay,
                rest = _objectWithoutProperties(_props, ['label', 'overlay']);

            var _state = this.state,
                isFocused = _state.isFocused,
                isHovered = _state.isHovered;

            var isHidden = !(isFocused || isHovered);

            var labelProps = {
                labelAttributes: {
                    tabIndex: '0',
                    'aria-describedby': this.identifier,
                    onFocus: this.onFocus
                },
                isHidden: isHidden
            };

            var overlayProps = {
                overlayAttributes: {
                    role: 'tooltip',
                    tabIndex: '-1',
                    id: this.identifier,
                    'aria-hidden': isHidden.toString()
                },
                isHidden: isHidden
            };

            return React__default.createElement(
                'div',
                _extends({}, rest, {
                    onBlur: this.onBlur,
                    ref: function ref(_ref4) {
                        _this2.container = _ref4;
                    },
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave
                }),
                React__default.createElement(Label, labelProps),
                React__default.createElement(Overlay, overlayProps)
            );
        }
    }]);

    return Tooltip;
}(React.Component);

exports.Tooltip = Tooltip;

Object.defineProperty(exports, '__esModule', { value: true });

})));
